import { useNormalizedLocale } from 'hooks/useNormalizedLocale';
import gregorian_en from 'react-date-object/locales/gregorian_en';
import { CalendarProps as CalendarComponentProps } from 'react-multi-date-picker';

import { CalendarStyled } from './Calendar.styled';
import { RUSSIAN_LOCALE } from './constants/locale';

export interface CalendarProps<Multiple extends boolean = false, Range extends boolean = false>
  extends CalendarComponentProps<Multiple, Range> {
  gap?: string;
}

const LOCALES = {
  en: gregorian_en,
  ru: RUSSIAN_LOCALE,
};

export function Calendar<Multiple extends boolean = false, Range extends boolean = false>(
  props: CalendarProps<Multiple, Range>,
) {
  const normalizedLocale = useNormalizedLocale(LOCALES);

  return (
    <CalendarStyled autoFocus={true} locale={normalizedLocale} weekStartDayIndex={1} {...props} />
  );
}
